import * as React from 'react';
import JsxParser from './JsxParser';

interface HtmlContentProps {
  html: string;
  components?: Object;
  args?: { [key: string]: string };
}

export default function HtmlContent(props: HtmlContentProps) {
  let htmlContent = props.html && props.html.replace(/<!--.*?-->/g, '');
  if (props.args) {
    Object.keys(props.args).forEach(argKey => {
      htmlContent = htmlContent.replace(
        /* eslint-disable-next-line prefer-template */
        '${' + argKey + '}',
        // @ts-ignore
        props.args[argKey]
      );
      htmlContent = htmlContent.replace(
        /* eslint-disable-next-line prefer-template */
        '{' + argKey + '}',
        // @ts-ignore
        props.args[argKey]
      );
    });
  }
  return (
    <JsxParser
      renderInWrapper={false}
      components={props.components}
      onError={(e: any) => {
        /* eslint-disable no-console */
        console.log('Error in loading content');
        console.log(e);
        /* eslint-disable no-console */
      }}
      jsx={htmlContent}
    />
  );
}
